import { useState } from 'react'
import { Accordion } from '@sweetspot/scramble-ds/atoms'

interface AccordionInstructionsProps {
  title: string
  children: React.ReactNode
}

export const AccordionInstructions = ({ title, children }: AccordionInstructionsProps) => {
  const [accordionValue, setAccordionValue] = useState<string[]>(['accordion-1'])

  return (
    <Accordion.Root
      type="multiple"
      orientation="horizontal"
      value={accordionValue}
      onValueChange={setAccordionValue}
      className="mt-2"
    >
      <Accordion.Item
        value="accordion-1"
        className="border-border-stroke-pale w-full max-w-full overflow-hidden rounded-md border-2"
      >
        <Accordion.Trigger className="py-2">
          <Accordion.Label className="font-normal">{title}</Accordion.Label>
        </Accordion.Trigger>

        <Accordion.Content className="bg-background-base-neutral border-t">
          {children}
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  )
}
